export default "__VITE_ASSET__DLJIHMte__"